module.exports = __webpack_public_path__ + "img/option-list-arr.0f70e405.svg";